(function () {
  var EMBED_API = 'https://tablemaster-v2.activory.com/api/v1/embed-tables/';
  var DEFAULT_COLUMNS = ['c1', 'c2', 'c16', 'c15', 'c14', 'c13', 'c12', 'c5', 'c8'];
  var SWATCH_SELECTOR = '.mpg-swatch, [class*="mpg-swatch"]';
  var MOBILE_QUERY = '(max-width: 767px)';
  var LOAD_ERROR = 'The comparison table could not be loaded.';

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function parseJson(script) {
    if (!script) return {};
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return {};
    }
  }

  function findSwatch(section) {
    var nodes = section.querySelectorAll(SWATCH_SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.closest('.oel-sticky-atc')) continue;
      if (el.parentElement && el.parentElement.closest(SWATCH_SELECTOR)) continue;
      return el;
    }
    return null;
  }

  function placeBlocks(section) {
    var title = section.querySelector('.product__block__title');
    var actions = section.querySelector('.product-oel__cart-row-actions');
    var swatch = findSwatch(section);
    var root = section.querySelector('[data-oel-concentration-comparison]');
    var quantity = actions && actions.querySelector('.product__block__quantity');

    if (isMobile() && title) {
      if (swatch && title.nextElementSibling !== swatch) title.after(swatch);
      if (root) {
        var after = swatch && swatch.parentNode === title.parentNode ? swatch : title;
        if (after.nextElementSibling !== root) after.after(root);
      }
      return;
    }

    if (actions && swatch) {
      if (!actions.contains(swatch)) actions.insertBefore(swatch, quantity || actions.firstChild);
      if (root && swatch.nextElementSibling !== root) swatch.after(root);
      return;
    }

    if (actions && root && (root.parentNode !== actions || (quantity && root.nextElementSibling !== quantity))) {
      actions.insertBefore(root, quantity || actions.firstChild);
    }
  }

  function watchSection(section) {
    if (section.dataset.oelPlaceReady === 'true') return;
    section.dataset.oelPlaceReady = 'true';

    var scheduled = false;
    function schedulePlace() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        placeBlocks(section);
      });
    }

    placeBlocks(section);
    new MutationObserver(schedulePlace).observe(
      section.querySelector('[data-product-form-wrapper]') || section,
      { childList: true, subtree: true }
    );
    window.matchMedia(MOBILE_QUERY).addEventListener('change', schedulePlace);
  }

  function moneyFormat() {
    return (window.theme && window.theme.moneyFormat) ||
      (window.Shopify && window.Shopify.money_format) ||
      '€{{amount}}';
  }

  function decodeHtml(html) {
    var el = document.createElement('textarea');
    el.innerHTML = html;
    return el.value;
  }

  function formatPrice(amount) {
    var cents = Math.round(Number(String(amount).replace(',', '.')) * 100);
    if (!isFinite(cents)) return '';
    var format = moneyFormat();
    var currency = window.themeVendor && window.themeVendor.themeCurrency;
    var formatted = '';
    if (currency && typeof currency.formatMoney === 'function') {
      formatted = currency.formatMoney(cents, format);
    } else if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      formatted = window.Shopify.formatMoney(cents, format);
    } else {
      var value = (cents / 100).toFixed(2);
      var withComma = value.replace('.', ',');
      formatted = decodeHtml(String(format))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(cents / 100)))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
        .replace(/\{\{\s*amount\s*\}\}/g, value);
    }
    return decodeHtml(formatted).replace(/<[^>]*>/g, '').trim();
  }

  function formatPriceCells(table) {
    if (!table) return;
    table.querySelectorAll('.tm-product-price[data-price], .product-price[data-price]').forEach(function (el) {
      var formatted = formatPrice(el.getAttribute('data-price'));
      if (formatted) el.textContent = formatted;
    });
  }

  function columnOrderFromHtml(html) {
    var order = [];
    var match;
    var re = /\{data:\s*['"]([^'"]+)['"]/g;
    while ((match = re.exec(html))) order.push(match[1]);
    return order.length ? order : DEFAULT_COLUMNS;
  }

  function productUrlFromRow(tr) {
    var productLink = tr.querySelector('a[href*="/products/"]');
    if (productLink && productLink.getAttribute('href')) return productLink.getAttribute('href');

    var handleNode = tr.querySelector('[data-product-handle]');
    if (handleNode && handleNode.getAttribute('data-product-handle')) {
      return '/products/' + handleNode.getAttribute('data-product-handle');
    }

    var node = tr.querySelector('[data-product-url], [data-url], [data-product-handle], [data-handle]');
    if (node) {
      var url = node.getAttribute('data-product-url') || node.getAttribute('data-url');
      if (url) return url;
      var handle = node.getAttribute('data-product-handle') || node.getAttribute('data-handle');
      if (handle) return '/products/' + handle;
    }

    var formLink = tr.querySelector('form[action*="/cart/add"] a[href], .oel-concentration-product-link');
    return (formLink && formLink.getAttribute('href')) || '';
  }

  function replaceCartColumn(table, label) {
    if (!table || !label) return;
    var headers = table.querySelectorAll('thead th');
    var index = -1;

    headers.forEach(function (th, i) {
      var text = (th.textContent || '').replace(/\s+/g, ' ').trim();
      if (/add to cart|in den warenkorb|ajouter au panier|añadir al carrito|aggiungi al carrello|adicionar ao carrinho/i.test(text)) {
        index = i;
        th.textContent = label;
      }
    });

    if (index === -1 && headers.length) {
      index = headers.length - 1;
      headers[index].textContent = label;
    }

    table.querySelectorAll('tbody tr').forEach(function (tr) {
      var cell = tr.cells[index];
      if (!cell) return;
      var href = productUrlFromRow(tr);
      if (!href) return;
      cell.textContent = '';
      var link = document.createElement('a');
      link.className = 'oel-concentration-product-link';
      link.href = href;
      link.textContent = label;
      cell.appendChild(link);
    });
  }

  function copyColumnClasses(table) {
    var classes = [];
    var sources = [
      table.tHead && table.tHead.rows[0],
      table.tBodies[0] && table.tBodies[0].rows[0]
    ];
    sources.forEach(function (row) {
      if (!row) return;
      for (var i = 0; i < row.cells.length; i++) {
        if (!classes[i] && row.cells[i].className) classes[i] = row.cells[i].className;
      }
    });
    return classes;
  }

  function fillTableBody(table, rows, columns) {
    if (!table || !rows || !rows.length) return false;
    var classes = copyColumnClasses(table);
    var tbody = table.tBodies[0] || table.appendChild(document.createElement('tbody'));
    var frag = document.createDocumentFragment();
    tbody.textContent = '';
    rows.forEach(function (row) {
      var tr = document.createElement('tr');
      columns.forEach(function (key, i) {
        var td = document.createElement('td');
        var value = row[key];
        if (classes[i]) td.className = classes[i];
        if (i === 0 && td.className.indexOf('tm-image-column__image') === -1) {
          td.classList.add('tm-image-column__image');
        }
        td.innerHTML = value == null ? '' : String(value);
        tr.appendChild(td);
      });
      frag.appendChild(tr);
    });
    tbody.appendChild(frag);
    return true;
  }

  function flattenTable(mount, html) {
    var staging = document.createElement('div');
    staging.innerHTML = html;
    staging.querySelectorAll('script').forEach(function (script) {
      script.remove();
    });

    var table = staging.querySelector('table');
    if (!table) {
      mount.innerHTML = staging.innerHTML;
      return null;
    }

    mount.textContent = '';
    staging.querySelectorAll('style').forEach(function (style) {
      mount.appendChild(style);
    });
    mount.appendChild(table);
    return table;
  }

  function fetchJson(url) {
    return fetch(url, { credentials: 'omit' }).then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.json();
    });
  }

  function bind(root) {
    var openBtn = root.querySelector('[data-oel-concentration-open]');
    var closeBtns = root.querySelectorAll('[data-oel-concentration-close]');
    var dialog = root.querySelector('[data-oel-concentration-dialog]');
    var tableHolder = root.querySelector('[data-oel-concentration-table]');
    var statusEl = root.querySelector('[data-oel-concentration-status]');
    var shop = (window.Shopify && Shopify.shop) || root.getAttribute('data-shop') || '';
    var embeds = parseJson(root.querySelector('[data-oel-concentration-embeds]'));
    var requests = {};
    var section = root.closest('.product-oel, [data-section-type="product"]') || document;
    if (!openBtn || !dialog || !tableHolder || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    function embedFor(variantId) {
      if (variantId == null) return '';
      var value = embeds[String(variantId)];
      return value ? String(value).trim() : '';
    }

    function currentMount() {
      return tableHolder.querySelector('[data-embed-id]');
    }

    function currentEmbedId() {
      return embedFor(root.getAttribute('data-current-variant'));
    }

    function setStatus(message) {
      if (!statusEl) return;
      statusEl.hidden = !message;
      statusEl.textContent = message || '';
    }

    function ensureMount(embedId) {
      var mount = currentMount();
      if (mount && mount.getAttribute('data-embed-id') === embedId) return mount;
      var next = document.createElement('div');
      next.setAttribute('data-embed-id', embedId);
      if (mount) mount.replaceWith(next);
      else tableHolder.appendChild(next);
      return next;
    }

    function loadEmbed(embedId) {
      if (!embedId) {
        setStatus(LOAD_ERROR);
        return;
      }
      var mount = ensureMount(embedId);
      if (mount.getAttribute('data-loaded-id') === embedId && mount.querySelector('tbody tr')) return;
      if (requests[embedId]) return requests[embedId];

      setStatus('Loading table…');
      var query = '?shop=' + encodeURIComponent(shop);
      requests[embedId] = Promise.all([
        fetchJson(EMBED_API + encodeURIComponent(embedId) + query),
        fetchJson(EMBED_API + encodeURIComponent(embedId) + '/data' + query + '&draw=1&start=0&length=250'),
      ]).then(function (results) {
        var html = results[0] && results[0].body;
        var rows = (results[1] && results[1].data) || [];
        if (!html) throw new Error('empty');

        mount = ensureMount(embedId);
        var table = flattenTable(mount, html);
        if (fillTableBody(table, rows, columnOrderFromHtml(html))) {
          formatPriceCells(table);
          replaceCartColumn(table, root.getAttribute('data-view-product') || 'View product');
          mount.setAttribute('data-loaded-id', embedId);
          setStatus('');
        } else {
          setStatus(LOAD_ERROR);
        }
      }).catch(function () {
        setStatus(LOAD_ERROR);
        delete requests[embedId];
      });

      return requests[embedId];
    }

    function closeDialog() {
      dialog.classList.remove('is-open');
      dialog.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      root.appendChild(dialog);
    }

    function applyVariant(variantId) {
      var embedId = embedFor(variantId);
      root.hidden = !embedId;
      root.setAttribute('data-current-variant', variantId || '');
      if (!dialog.classList.contains('is-open')) return;
      if (embedId) loadEmbed(embedId);
      else closeDialog();
    }

    openBtn.addEventListener('click', function (event) {
      event.preventDefault();
      document.body.appendChild(dialog);
      dialog.classList.add('is-open');
      dialog.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      loadEmbed(currentEmbedId());
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeDialog);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && dialog.classList.contains('is-open')) closeDialog();
    });

    section.addEventListener('theme:variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (variant) applyVariant(variant.id);
    });
  }

  function initAll() {
    document.querySelectorAll('.product-oel').forEach(watchSection);
    document.querySelectorAll('[data-oel-concentration-comparison]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
